import AtividadeNova from './AtividadeNova';

export default AtividadeNova;